export default {
	storeUserList(state, users) {
    state.users = users;
  },
  storeUser(state,user) {
    state.user = user
  },
  storeCreatedUser(state,createdUser) {
    state.users = state.users.concat(createdUser);
  },
  storeUpdatedUser(state,updatedUser) {
    state.user = updatedUser
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js